import { useFormatters } from '@earzzai/i18n-react';
import { useMemo } from 'react';
import { Trans } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import { EarzzOfficialTimeZoneId } from '../utils/timezone';

export const LegalFooter = () => {
  const { formatDateTime } = useFormatters();
  const today = useMemo(
    () => Temporal.Now.plainDateISO(EarzzOfficialTimeZoneId),
    []
  );
  return (
    <ul className="flex justify-center text-sm">
      <li className="inline">
        <Trans
          i18nKey="components.LegalFooter.copyright"
          values={{ year: formatDateTime(today, { year: 'numeric' }) }}
        />
      </li>
      <li className="inline before:content-['\00a0|\00a0'] print:hidden">
        <NavLink
          to="https://www.earzz.com/privacy-policy"
          className="underline hover:no-underline"
          rel="noreferrer"
          target="_blank"
        >
          <Trans i18nKey="components.LegalFooter.privacyPolicy" />
        </NavLink>
      </li>
    </ul>
  );
};
